import get from 'lodash/get';
import * as personIndexSectionNextActions from '../../action_creators/mcp/person_index_section_next_action_creators';
import PersonIndexSectionNextModel from '../../../models/mcp/person_index_section_next_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(
      personIndexSectionNextActions.personIndexSectionNextLoading({}, store)
    );
    return PersonIndexSectionNextModel.fetch(params, store)
      .then(function handlePersonDetailData(PersonData) {
        dispatch(
          personIndexSectionNextActions.personIndexSectionNextLoaded(
            PersonData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in person actions, message: ${err.message}`);
        }

        dispatch(
          personIndexSectionNextActions.personIndexSectionNextLoadError(
            err,
            store
          )
        );
      });
  };
}
